import * as React from 'react';
import { Row, Col } from 'antd';
import { observer } from 'mobx-react';
import { Prompt } from 'react-router';

import { BooleanView } from 'src/core/ui/boolean.view';
import { TabLanguageController } from 'src/core/ui/language/tab-language.controller';
import { PolicyRuleDataService } from 'src/app/bookings/policy-rules/policy-rule-form.data';
import { GenericPolicyFormView } from 'src/app/bookings/policies/generic-policy-form.view';
import { ContextService } from 'src/core/services/context.service';
import { TextView } from 'src/core/ui/text.view';
import { PriceRoundingTypeEditor } from 'src/app/general/market/form/parts/price-rounding-type-editor';

interface Props extends ComponentViewProps<SellMarginPolicyItem> {
	title: string,
	save: () => Promise<void>;
	cancel: () => void;
	mode: ControlMode;
	onModeChange: (mode: ControlMode) => void;
	policyRuleDataService: PolicyRuleDataService;
	breadcrumb: any[];
	goToCard: (text: any, key: string, model: PolicyRuleItem, parentModel?: Model) => void;
	contextService: ContextService;
}

@observer
export class SellMarginPolicyFormView extends React.Component<Props, {}> {
	render(): React.ReactNode {
		const { model, mode, setBusy, contextService } = this.props;
		const translations = (model as any).dynamicProperties['displayName'];
		const array: TabLanguageModel[] = [
			{
				title: 'Name',
				dynamicProperties: translations,
				rows: 2
			}
		];

		return (
			<React.Fragment>
				<Prompt
					when={contextService.isDirty}
					message={location => `If you go to ${location.pathname}, all changes will be lost. Are you sure you want to continue?`}
				/>
				<GenericPolicyFormView
					rulesSections={['general', 'product']}
					policyRuleOwner={{
						sellMarginPolicyId: model.id,
						sellMarginPolicy: model
					}}
					{...this.props}
				>
					<Row>
						<Col xs={24}>
							<TabLanguageController
								model={model}
								dynamicProperties={array}
								mode={mode}
								setBusy={setBusy}
								isRichTextBox={false}
							/>
						</Col>
						<Col xs={24}>
							<TextView
								required
								label="Margin"
								value={model.margin}
								onChanged={(newVal) => {
									model.margin = newVal != null ? newVal : null;
								}}
								validate={value => value === '' || (/^\d+([.]\d*)?$/.test(value) && parseFloat(value) <= 1)}
								mode={mode}
								onGetErrorMessage={() => model.validate(false, 'margin')}
								format="percent"
								suffix="%"
							/>
						</Col>
						<Col xs={24}>
							<PriceRoundingTypeEditor
								required
								value={model.priceRoundingType}
								mode={mode}
								onChange={(item) => {
									model.priceRoundingType = item;
								}}
							/>
						</Col>
						<Col xs={24}>
							<TextView
								required
								label="Priority"
								value={model.priority}
								onChanged={(newVal) => {
									model.priority = newVal;
								}}
								targetType="int"
								mode={mode}
								onGetErrorMessage={() => model.validate(false, 'margin')}
							/>
						</Col>
						<Col xs={24}>
							<BooleanView
								label="Active"
								value={model.isActive}
								onChanged={(newVal) => {
									model.isActive = newVal;
								}}
								mode={this.props.mode}
							/>
						</Col>
					</Row>
				</GenericPolicyFormView>
			</React.Fragment>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/bookings/sell-margin-policies/form/sell-margin-policy-form.view.tsx